import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["innerHTML"]

import { computed, onBeforeUnmount, onMounted, ref } from "vue";
import { SETTINGS_TITLES, type SettingsKey, useSettingsText } from "@/composables/useSettings";
import { EventBus, EventBusNames } from "@/utils/EventBus";
import { toggleModal } from "@/utils/Helper";

const settingsModalId = "settings-modal";

export default /*@__PURE__*/_defineComponent({
  __name: 'TermsComponent',
  setup(__props) {

const EVENT_KEYS: Record<string, SettingsKey> = { terms: "terms-of-use", policy: "privacy-policy" };

const key = ref<SettingsKey | "">("");
const info = computed(() => ({ screenTitle: key.value ? SETTINGS_TITLES[key.value] : "" }));
const { data: text, isFetching: loading } = useSettingsText(key);

const open = (data: { key: string }) => {
  key.value = EVENT_KEYS[data.key] ?? "";
  toggleModal(settingsModalId);
};
onMounted(() => EventBus.$on(EventBusNames.SHOW_SETTINGS_MODAL, open));
onBeforeUnmount(() => EventBus.$off(EventBusNames.SHOW_SETTINGS_MODAL, open));

return (_ctx: any,_cache: any) => {
  const _component_LoadingContainer = _resolveComponent("LoadingContainer")!
  const _component_ModalComponent = _resolveComponent("ModalComponent")!

  return (_openBlock(), _createBlock(_component_ModalComponent, {
    id: settingsModalId,
    size: "modal-lg",
    title: info.value.screenTitle,
    "modal-class": "app-sheet app-sheet-tall text-primary",
    backdrop: "true"
  }, {
    body: _withCtx(() => [
      (_unref(loading))
        ? (_openBlock(), _createBlock(_component_LoadingContainer, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "text-paragraph settings-text",
            innerHTML: _unref(text)
          }, null, 8, _hoisted_1))
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})